import propTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Controller } from 'react-hook-form';
import { useSelector } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import IOSSwitch from 'components/IOSSwitch';
import { useDirectoryName } from 'common/hooks/use-directory-name';
import styles from './styles';

const FilingCabinetBlock = ({ classes, control }) => {
  const organizationSettings = useSelector((state) => state.settings?.settings || {});
  const directoryName = useDirectoryName();

  return (
    <div>
      <Typography variant="h4">Filing Cabinet</Typography>
      <div className={classes.switchRow}>
        <Controller
          name="businessFilingCabinet"
          control={control}
          defaultValue={organizationSettings?.businessFilingCabinet || false}
          render={({ name, value, onChange }) => (
            <IOSSwitch
              name={name}
              small
              checked={value}
              onChange={(e) => onChange(e.target.checked)}
            />
          )}
        />
        <span className={classes.label}>{directoryName}</span>
      </div>
    </div>
  );
};

FilingCabinetBlock.propTypes = {
  classes: propTypes.object.isRequired,
  control: propTypes.object.isRequired,
};

export default withStyles(styles)(FilingCabinetBlock);
